import { useState } from 'react';
import Box from '@mui/material/Box';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import {useTranslation} from "react-i18next";

export default function CategorySelect(props) {
  const { i18n } = useTranslation();

  const [cat, setCat] = useState('');

  const handleChange = (event) => {
    const category = event.target.value
    setCat(category);
    props.handleSelectCategory(category)
  };
  const direction = i18n.language === 'en' ? 'ltr' : 'rtl'

  return (
    <Box sx={{ minWidth: 120 }} dir={direction}>
      <FormControl fullWidth>
        <Select
          value={cat}
          onChange={handleChange}
        >
          {props.categories.map((item) => <MenuItem sx={{direction: direction}} value={item.id} key={item.id}>
            {item.name}
            </MenuItem>)}
        </Select>
      </FormControl>
    </Box>
  );
}
